module.exports = __webpack_public_path__ + "img/pr-4.95561a33.png";